const environment = {
  port: 9000,
  production: true,
};

export { environment };
